/**
 * Automation Editor — Page logic for automations/edit
 *
 * Expects these globals set by Blade before this file loads:
 *   - triggerVariables, currentTriggerType
 *   - conditionOperators, transactionStatuses, mandateStatuses, commissionStatuses
 *   - formOptions, nodeTypeMeta
 *   - automationEditorConfig { testActionUrl, csrfToken, userEmail }
 */

function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}

var editor;
var editingNodeId = null;
var currentEditorType = null;
var lastFocusedVarTarget = null;
var workflowInitialised = false;

function markUnsaved() {
    var $el = $('#saveStatus');
    $el.removeClass('is-saved').addClass('is-unsaved')
       .html('<i class="fad fa-circle mr-1" style="font-size:6px;vertical-align:middle;"></i>Unsaved changes')
       .show();
    $('#btnSubmitLabel').text('Save Changes');
}

function markSaved() {
    var $el = $('#saveStatus');
    $el.removeClass('is-unsaved').addClass('is-saved')
       .html('<i class="fad fa-check mr-1"></i>Saved')
       .show();
    setTimeout(function() { $el.fadeOut(800); }, 2500);
    $('#btnSubmitLabel').text($('#btnSubmit').data('default-label'));
}

$(document).ready(function() {
    editor = new SimpleWorkflowEditor('workflowCanvas', {
        minimapId: 'workflowMinimap',
        containerSelector: '#workflow-container',
        onSave: function(data) {
            $('#workflowJsonInput').val(JSON.stringify(data));
            updateWorkflowStatus();
            if (workflowInitialised) markUnsaved();
        },
        onNodeDoubleClick: function(node) {
            openNodeEditor(node);
        },
        onSelectTrigger: function() {
            openTriggerSlideover();
        }
    });

    var workflowData = JSON.parse($('#workflowJsonInput').val() || '{"nodes":[],"connections":[]}');
    editor.loadWorkflow(workflowData);
    updateWorkflowStatus();
    updateWorkflowEmptyState();
    workflowInitialised = true;

    $('#btnZoomIn').on('click', function() { editor.zoomIn(); updateZoomLabel(); });
    $('#btnZoomOut').on('click', function() { editor.zoomOut(); updateZoomLabel(); });
    $('#btnFitView').on('click', function() { editor.autoFitView(); updateZoomLabel(); });
    $('#btnUndo').on('click', function() { editor.undo(); updateUndoRedo(); });
    $('#btnRedo').on('click', function() { editor.redo(); updateUndoRedo(); });
    $('#btnAddNode').on('click', function() { openActionSlideover(); });
    $('#btnFullscreen').on('click', toggleFullscreen);

    $('#confirmDeleteNode').on('click', function() {
        if (editingNodeId) {
            editor.deleteNode(editingNodeId);
            editingNodeId = null;

            var $msg = $('<div class="canvas-inline-msg canvas-inline-msg-danger"><i class="fa fa-trash-alt mr-1"></i> Node deleted</div>');
            $('#workflow-wrapper').append($msg);
            setTimeout(function() { $msg.addClass('show'); }, 10);
            setTimeout(function() { $msg.removeClass('show'); setTimeout(function() { $msg.remove(); }, 200); }, 2000);
        }
        $('#deleteNodeModal').modal('hide');
    });

    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            if ($('#workflow-wrapper').hasClass('is-fullscreen')) exitFullscreen();
            $('#shortcutsPanel').hide();
        }
        if ((e.ctrlKey || e.metaKey) && e.key === 's') {
            e.preventDefault();
            $('#automationForm').submit();
        }
    });

    var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    var mod = isMac ? '⌘' : 'Ctrl';
    var shortcuts = [
        [mod + ' + S', 'Save'],
        [mod + ' + Z', 'Undo'],
        [mod + ' + Y', 'Redo'],
        ['Del', 'Delete selected node'],
        ['Esc', 'Exit fullscreen'],
    ];
    var rows = shortcuts.map(function(s) {
        return '<tr><td class="pr-3"><kbd>' + s[0] + '</kbd></td><td class="text-muted">' + s[1] + '</td></tr>';
    }).join('');
    var panelHtml = '<div id="shortcutsPanel" class="shortcuts-panel">' +
        '<div class="font-weight-bold mb-2" style="font-size:12px;"><i class="fad fa-keyboard mr-1"></i> Keyboard Shortcuts</div>' +
        '<table style="font-size:12px;">' + rows + '</table></div>';
    $('#btnShortcuts').css('position', 'relative').append(panelHtml);

    $('#btnShortcuts').on('click', function(e) {
        e.stopPropagation();
        $('#shortcutsPanel').toggle();
    });
    $(document).on('click', function(e) {
        if (!$(e.target).closest('#shortcutsPanel, #btnShortcuts').length) {
            $('#shortcutsPanel').hide();
        }
    });

    editor.onDeleteRequest = function(nodeId) {
        editingNodeId = nodeId;
        $('#deleteNodeModal').modal('show');
    };

    $('input[name=sms_sub_action]').on('change', function() {
        var val = $(this).val();
        $('#smsFields_send').toggleClass('d-none', val !== 'send_sms');
        $('#smsFields_subscriber').toggleClass('d-none', val !== 'add_subscriber');
    });

    $(document).on('click', '.btn-group label:has(input[type=radio])', function() {
        var $input = $(this).find('input');
        $input.prop('checked', true).trigger('change');
        $(this).siblings('label').removeClass('active');
        $(this).addClass('active');
    });

    $('input[name=mailniaga_version]').on('change', function() {
        var ver = $(this).val();
        updateMailNiagaWarning();
        fetchMailNiagaLists(ver, '');
        $('#mailniagaCustomFieldsWrapper').toggleClass('d-none', ver !== 'v2');
        if (ver === 'v2') {
            $('#mailniagaCustomFields').empty();
            window._mailNiagaListFields = [];
        }
    });

    $(document).on('change', '#mailniaga_list_id', function() {
        var ver = $('input[name=mailniaga_version]:checked').val();
        if (ver === 'v2' && $(this).val()) {
            fetchMailNiagaListFields($(this).val());
        }
    });

    $('input[name=delay_type]').on('change', function() {
        $('#delayPeriodFields').toggleClass('d-none', $(this).val() !== 'period');
        $('#delayDatetimeFields').toggleClass('d-none', $(this).val() !== 'datetime');
        $('.delay-datetime-error').remove();
        if ($(this).val() === 'datetime') {
            var now = new Date();
            now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
            $('#delay_until_datetime').attr('min', now.toISOString().slice(0, 16));
        }
    });

    $(document).on('change', '#delay_until_datetime', function() {
        $('.delay-datetime-error').remove();
    });

    $.each(['query', 'headers', 'body'], function(i, section) {
        var capSection = section.charAt(0).toUpperCase() + section.slice(1);
        $('#webhook_' + section + '_enabled').on('change', function() {
            $('#webhook' + capSection + 'Section').toggleClass('d-none', !this.checked);
        });
        $('input[name=webhook_' + section + '_mode]').on('change', function() {
            var isForm = $(this).val() === 'form';
            $('#webhook' + capSection + 'Form').toggleClass('d-none', !isForm);
            $('#webhook' + capSection + 'Raw').toggleClass('d-none', isForm);
        });
    });

    $(document).on('focus', '.var-target', function() {
        lastFocusedVarTarget = this;
    });

    $(document).on('click', '.var-btn', function(e) {
        e.preventDefault();
        var varText = $(this).data('var');
        var $target = lastFocusedVarTarget ? $(lastFocusedVarTarget) : null;
        if ($target && $target.length && $target.is(':visible')) {
            var pos = $target[0].selectionStart || $target.val().length;
            var val = $target.val();
            $target.val(val.substring(0, pos) + varText + val.substring(pos));
            $target[0].selectionStart = $target[0].selectionEnd = pos + varText.length;
            $target.focus();
        } else {
            navigator.clipboard.writeText(varText).then(function() {
                showVarCopiedToast(varText);
            });
        }
    });

    updateVariableDropdowns();

    $('#automationForm input[name="name"]').on('input', function() {
        if (workflowInitialised) markUnsaved();
    });

    $('#automationForm').on('submit', function() {
        $(window).off('beforeunload');
    });

    $(window).on('beforeunload', function() {
        if ($('#saveStatus').hasClass('is-unsaved')) {
            return 'You have unsaved changes. Are you sure you want to leave?';
        }
    });
});

function updateZoomLabel() {
    $('#zoomLevel').text(Math.round(editor.zoom * 100) + '%');
}
function updateUndoRedo() {
    $('#btnUndo').prop('disabled', !editor.canUndo());
    $('#btnRedo').prop('disabled', !editor.canRedo());
}
function updateWorkflowStatus() {
    var trigger = editor.getTriggerNode();
    if (trigger && trigger.type === 'trigger') {
        var meta = nodeTypeMeta[trigger.subType] || {};
        $('#statusTriggerLabel').text(meta.title || trigger.label || trigger.subType);
        $('#statusTrigger').removeClass('text-muted').addClass('text-dark');
    } else {
        $('#statusTriggerLabel').text('No trigger');
        $('#statusTrigger').removeClass('text-dark').addClass('text-muted');
    }
    var count = editor.getNodeCount();
    $('#statusNodeCount').text(count + (count === 1 ? ' node' : ' nodes'));
}

function toggleFullscreen() {
    if ($('#workflow-wrapper').hasClass('is-fullscreen')) {
        exitFullscreen();
    } else {
        enterFullscreen();
    }
}
function enterFullscreen() {
    $('#workflow-wrapper').addClass('is-fullscreen');
    $('#btnFullscreen').html('<i class="fad fa-compress-arrows-alt"></i>').attr('title', 'Exit Fullscreen (Esc)');
    setTimeout(function() { editor.resizeCanvas(); }, 50);
}
function exitFullscreen() {
    $('#workflow-wrapper').removeClass('is-fullscreen');
    $('#btnFullscreen').html('<i class="fad fa-expand-arrows-alt"></i>').attr('title', 'Fullscreen');
    setTimeout(function() { editor.resizeCanvas(); }, 50);
}

function openSlideover(id) {
    var $el = $(id);
    $el.css('visibility', 'visible');
    requestAnimationFrame(function() { $el.addClass('show'); });
}
function closeSlideover(id) {
    var $el = $(id);
    $el.removeClass('show');
    setTimeout(function() { $el.css('visibility', 'hidden'); }, 260);
}

function openTriggerSlideover() { openSlideover('#triggerSlideover'); }
function closeTriggerSlideover() { closeSlideover('#triggerSlideover'); }
function updateWorkflowEmptyState() { $('#workflowEmptyState').toggle(!currentTriggerType); }
function filterTriggers() {
    var q = $('#triggerSearch').val().toLowerCase();
    $('#triggerList .trigger-item').each(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(q) > -1);
    });
}
function selectTrigger(btn) {
    var triggerType = $(btn).data('trigger');
    var label = $(btn).find('.font-weight-bold').text();
    currentTriggerType = triggerType;
    $('#triggerTypeInput').val(triggerType);
    editor.setTriggerNode(triggerType, label);
    closeTriggerSlideover();
    updateVariableDropdowns();
    updateWorkflowStatus();
    updateWorkflowEmptyState();
}

function openActionSlideover() { openSlideover('#actionSlideover'); }
function closeActionSlideover() { closeSlideover('#actionSlideover'); }
function filterActions() {
    var q = $('#actionSearch').val().toLowerCase();
    $('#actionList .action-item').each(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(q) > -1);
    });
}
function selectAction(btn) {
    var actionType = $(btn).data('action');
    var label = $(btn).data('label');
    var nodeType = 'action';
    if (actionType === 'delay') nodeType = 'delay';
    if (actionType === 'condition') nodeType = 'condition';
    editor.addNode(nodeType, actionType, label, { action_type: actionType });
    closeActionSlideover();
    updateWorkflowStatus();
}

function openNodeEditor(node) {
    editingNodeId = node.id;
    var d = node.data || {};

    if (node.type === 'trigger') {
        openTriggerSlideover();
        return;
    }

    var actionType = d.action_type || node.type;
    currentEditorType = actionType;

    $('.node-panel').removeClass('active');
    var $panel = $('.node-panel[data-editor="' + actionType + '"]');
    if (!$panel.length) return;
    $panel.addClass('active');

    var meta = nodeTypeMeta[actionType] || { icon: 'fa-cog', color: '#6b7280', bg: '#f3f4f6', title: 'Configure' };
    $('#nodeEditorIcon').css('background', meta.bg).html('<i class="fad ' + meta.icon + '" style="color:' + meta.color + ';"></i>');
    $('#nodeEditorTitle').text(meta.title);

    $('#nodeEditorLabel').val(node.label || meta.title).attr('placeholder', meta.title);

    if (actionType === 'delay') {
        populateDelayPanel(d);
    } else if (actionType === 'condition') {
        populateConditionPanel(d);
    } else {
        populatePanel(actionType, d);
    }

    // Integration warning
    var unconfiguredMsg = editor ? editor.getUnconfiguredReason(node) : '';
    var $warn = $('#integrationWarning');
    if (unconfiguredMsg) {
        var isDisabled = unconfiguredMsg.indexOf('disabled') !== -1;
        var isMissing = unconfiguredMsg.indexOf('not configured') !== -1 || unconfiguredMsg.indexOf('credentials') !== -1;
        var settingsUrl = (window.automationEditorConfig || {}).integrationSettingsUrl || '#';
        var linkHtml = '<a href="' + settingsUrl + '" target="_blank">Integration Settings</a>';

        $warn.removeClass('alert-warning alert-danger');
        $('#integrationWarningIcon').removeClass('text-warning text-danger');

        if (isMissing && !isDisabled) {
            $warn.addClass('alert-danger');
            $('#integrationWarningIcon').addClass('text-danger');
            $('#integrationWarningDesc').html('API credentials are missing. Please configure in ' + linkHtml + '.');
        } else {
            $warn.addClass('alert-warning');
            $('#integrationWarningIcon').addClass('text-warning');
            if (isDisabled && isMissing) {
                $('#integrationWarningDesc').html('Please enable and configure credentials in ' + linkHtml + '.');
            } else {
                $('#integrationWarningDesc').html('This integration is currently disabled. Enable it in ' + linkHtml + '.');
            }
        }

        $('#integrationWarningTitle').text(unconfiguredMsg);
        $warn.css('display', 'flex');
    } else {
        $warn.hide();
    }

    openSlideover('#nodeEditorSlideover');

    $('#nodeEditorPanel').toggleClass('panel-wide', actionType === 'send_email' || actionType === 'webhook');

    // TinyMCE needs slideover visible first
    if (actionType === 'send_email') {
        setTimeout(function() { initEmailEditor(); }, 300);
    }

    var testable = ['send_email','send_whatsapp','send_wabot','send_wasapbot','add_to_smsniaga','add_to_mailniaga','add_to_googlesheets','webhook'];
    var $testBtn = $('#btnTestAction');
    $testBtn.toggle(testable.indexOf(actionType) > -1);
    var testLabel = 'Test Send';
    if (actionType === 'webhook') testLabel = 'Test Webhook';
    else if (actionType === 'add_to_googlesheets') testLabel = 'Test Google Sheets';
    $testBtn.find('span').text(testLabel);
}

function closeNodeEditor() {
    if (currentEditorType === 'send_email') {
        var ed = tinymce.get('email_body');
        if (ed) {
            $('#email_body').val(ed.getContent());
            ed.remove();
        }
    }
    $('#testActionArea').hide();
    $('#testResultMsg').empty();
    $('#testInlineMsg').empty();
    closeSlideover('#nodeEditorSlideover');
    editingNodeId = null;
    currentEditorType = null;
}

function initEmailEditor() {
    if (tinymce.get('email_body')) return;
    tinymce.init(Object.assign({}, editor_config, {
        selector: '#email_body',
        height: 280,
        menubar: false,
        toolbar: 'code | undo redo | styleselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | link image | removeformat',
        setup: function(ed) {
            ed.on('change keyup', function() {
                ed.save();
            });
        }
    }));
}

function saveCurrentNode() {
    if (!editingNodeId || !currentEditorType) return;
    var data;
    if (currentEditorType === 'delay') {
        data = collectDelayData();
        if (data.delay_type === 'datetime' && data.delay_until_datetime) {
            $('.delay-datetime-error').remove();
            if (new Date(data.delay_until_datetime) <= new Date()) {
                $('#delay_until_datetime').before('<div class="text-danger text-12 mb-1 delay-datetime-error"><i class="fa fa-exclamation-triangle mr-1"></i>Date/time must be in the future</div>');
                return;
            }
        }
    } else if (currentEditorType === 'condition') {
        data = collectConditionData();
    } else {
        if (currentEditorType === 'send_email') {
            var ed = tinymce.get('email_body');
            if (ed) $('#email_body').val(ed.getContent());
        }
        data = collectPanelData(currentEditorType);
    }

    var validationError = validateNodeData(currentEditorType, data);
    if (validationError) {
        showNodeValidationError(validationError);
        return;
    }

    var newLabel = $('#nodeEditorLabel').val().trim();
    editor.updateNode(editingNodeId, { label: newLabel || undefined, data: data });
    closeNodeEditor();

    var $msg = $('<div class="canvas-inline-msg canvas-inline-msg-success"><i class="fa fa-check mr-1"></i> Node settings saved</div>');
    $('#workflow-wrapper').append($msg);
    setTimeout(function() { $msg.addClass('show'); }, 10);
    setTimeout(function() { $msg.removeClass('show'); setTimeout(function() { $msg.remove(); }, 200); }, 2000);
}

function validateNodeData(actionType, data) {
    switch (actionType) {
        case 'send_email':
            if (!data.email_to) return 'To (email) is required';
            if (!data.email_subject) return 'Subject is required';
            if (!data.email_body) return 'Body is required';
            break;
        case 'send_whatsapp':
            if (!data.whatsapp_to) return 'Phone number is required';
            if (!data.whatsapp_message) return 'Message is required';
            break;
        case 'send_wabot':
            if (!data.wabot_to) return 'Phone number is required';
            if (!data.wabot_message) return 'Message is required';
            break;
        case 'send_wasapbot':
            if (!data.wasapbot_to) return 'Phone number is required';
            if (!data.wasapbot_message) return 'Message is required';
            break;
        case 'add_to_smsniaga':
            var sub = data.sms_sub_action || 'send_sms';
            if (sub === 'send_sms') {
                if (!data.sms_to) return 'Phone number is required';
                if (!data.sms_message) return 'Message is required';
            } else {
                if (!data.sms_group_uuid) return 'Group is required';
                if (!data.sms_subscriber_name) return 'Subscriber name is required';
                if (!data.sms_subscriber_phone) return 'Subscriber phone is required';
            }
            break;
        case 'add_to_mailniaga':
            if (!data.mailniaga_list_id) return 'List is required';
            if (!data.mailniaga_email) return 'Email is required';
            break;
        case 'add_to_googlesheets':
            if (!data.spreadsheet_id) return 'Spreadsheet is required';
            if (!data.sheet_name) return 'Sheet is required';
            if (data.gs_action === 'update_row') {
                if (!data.lookup_column) return 'Lookup column is required';
                if (!data.lookup_value) return 'Lookup value is required';
                var hasUpdates = (data.update_values || []).some(function(v) { return v.column && v.value; });
                if (!hasUpdates) return 'At least one update value is required';
            } else {
                var hasValues = (data.column_values || []).some(function(v) { return v.value; });
                if (!hasValues) return 'At least one column value is required';
            }
            break;
        case 'webhook':
            if (!data.webhook_url) return 'URL is required';
            break;
        case 'delay':
            if (data.delay_type === 'period') {
                if (!data.delay_value || data.delay_value <= 0) return 'Delay value is required';
            } else if (data.delay_type === 'datetime') {
                if (!data.delay_until_datetime) return 'Date & time is required';
            }
            break;
        case 'condition':
            if (!data.conditions || !data.conditions.length) return 'At least one condition is required';
            var emptyCondition = data.conditions.some(function(c) { return !c.field || !c.operator; });
            if (emptyCondition) return 'All conditions must have a field and operator';
            break;
    }
    return null;
}

function showNodeValidationError(msg) {
    $('.node-validation-error').remove();
    var $err = $('<div class="alert alert-danger py-2 px-3 node-validation-error" style="font-size:12px; margin:8px 0 0;"><i class="fa fa-exclamation-triangle mr-1"></i></div>').append(document.createTextNode(msg));
    $('.node-panel.active').append($err);
    setTimeout(function() { $err.fadeOut(300, function() { $err.remove(); }); }, 4000);
}

function toggleTestArea() {
    var noRecipientTypes = ['add_to_googlesheets', 'add_to_mailniaga'];
    if (noRecipientTypes.indexOf(currentEditorType) > -1) {
        executeTest();
        return;
    }

    var $area = $('#testActionArea');
    var isVisible = $area.is(':visible');
    $area.slideToggle(150);
    $('#testResultMsg').empty();

    if (!isVisible) {
        var emailTypes = ['send_email'];
        var phoneTypes = ['send_whatsapp', 'send_wabot', 'send_wasapbot', 'add_to_smsniaga'];
        var isEmail = emailTypes.indexOf(currentEditorType) > -1;
        var isPhone = phoneTypes.indexOf(currentEditorType) > -1;
        var isWebhook = currentEditorType === 'webhook';
        var cfg = window.automationEditorConfig || {};

        if (isWebhook) {
            $('#testRecipientLabel').show().html('<i class="fad fa-globe mr-1"></i> URL');
            $('#testRecipient').show().val($('#webhook_url').val() || '').attr('type', 'text').attr('readonly', true)
                .attr('placeholder', '').css('background-color', '#e9ecef');
        } else if (isEmail) {
            $('#testRecipientLabel').show().html('<i class="fad fa-at mr-1"></i> Email');
            $('#testRecipient').show().attr('placeholder', cfg.userEmail || 'test@example.com')
                .val(cfg.userEmail || '').attr('type', 'email').attr('readonly', false).css('background-color', '');
        } else if (isPhone) {
            $('#testRecipientLabel').show().html('<i class="fad fa-phone mr-1"></i> Phone');
            $('#testRecipient').show().attr('placeholder', '60123456789')
                .val('').attr('type', 'text').attr('readonly', false).css('background-color', '');
        } else {
            $('#testRecipientLabel').show().html('<i class="fad fa-globe mr-1"></i> Target');
            $('#testRecipient').show().attr('placeholder', '').val('').attr('type', 'text').attr('readonly', false).css('background-color', '');
        }
    }
}

function executeTest() {
    if (!currentEditorType) return;

    if (currentEditorType === 'send_email') {
        var ed = tinymce.get('email_body');
        if (ed) $('#email_body').val(ed.getContent());
    }
    var data = collectPanelData(currentEditorType);

    // Validate required fields before sending test
    var validationError = validateNodeData(currentEditorType, data);
    if (validationError) {
        showNodeValidationError(validationError);
        return;
    }

    var noRecipientTypes = ['add_to_googlesheets', 'add_to_mailniaga'];
    var isNoRecipient = noRecipientTypes.indexOf(currentEditorType) > -1;

    var $btn = isNoRecipient ? $('#btnTestAction') : $('#btnTestSend');
    var $msg = isNoRecipient ? $('#testInlineMsg') : $('#testResultMsg');
    var origHtml = $btn.html();
    $btn.prop('disabled', true).html('<i class="fad fa-spinner fa-spin mr-1"></i> Testing...');
    $msg.empty();
    var testRecipient = $('#testRecipient').val().trim();
    var cfg = window.automationEditorConfig || {};

    $.ajax({
        url: cfg.testActionUrl,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            _token: cfg.csrfToken,
            action_type: currentEditorType,
            node_data: data,
            test_recipient: testRecipient
        }),
        success: function(res) {
            $btn.html(origHtml).prop('disabled', false);
            $msg.html('<span class="text-success"><i class="fad fa-check-circle mr-1"></i>' + escapeHtml(res.message || 'Success!') + '</span>');
            if (isNoRecipient) setTimeout(function() { $msg.fadeOut(400, function() { $msg.empty().css('display', ''); }); }, 4000);
        },
        error: function(xhr) {
            var msg = (xhr.responseJSON && xhr.responseJSON.message) || 'Test failed';
            $btn.html(origHtml).prop('disabled', false);
            $msg.html('<span class="text-danger"><i class="fad fa-exclamation-circle mr-1"></i>' + escapeHtml(msg) + '</span>');
            if (isNoRecipient) setTimeout(function() { $msg.fadeOut(400, function() { $msg.empty().css('display', ''); }); }, 5000);
        }
    });
}

function collectPanelData(actionType) {
    var data = { action_type: actionType };
    switch (actionType) {
        case 'send_email':
            data.email_to = $('#email_to').val();
            data.email_subject = $('#email_subject').val();
            data.email_body = $('#email_body').val();
            break;
        case 'send_whatsapp':
            data.whatsapp_to = $('#whatsapp_to').val();
            data.whatsapp_message = $('#whatsapp_message').val();
            break;
        case 'send_wabot':
            data.wabot_to = $('#wabot_to').val();
            data.wabot_message = $('#wabot_message').val();
            break;
        case 'send_wasapbot':
            data.wasapbot_to = $('#wasapbot_to').val();
            data.wasapbot_message = $('#wasapbot_message').val();
            break;
        case 'add_to_smsniaga':
            data.sms_sub_action = $('input[name=sms_sub_action]:checked').val() || 'send_sms';
            data.sms_to = $('#sms_to').val();
            data.sms_message = $('#sms_message').val();
            data.sms_sender_id = $('#sms_sender_id').val();
            data.sms_group_uuid = $('#sms_group_uuid').val();
            data.sms_subscriber_name = $('#sms_subscriber_name').val();
            data.sms_subscriber_phone = $('#sms_subscriber_phone').val();
            data.sms_subscriber_email = $('#sms_subscriber_email').val();
            break;
        case 'add_to_mailniaga':
            data.mailniaga_version = $('input[name=mailniaga_version]:checked').val() || 'v1';
            data.mailniaga_list_id = $('#mailniaga_list_id').val();
            data.mailniaga_email = $('#mailniaga_email').val();
            data.mailniaga_name = $('#mailniaga_name').val();
            if (data.mailniaga_version === 'v2') {
                data.mailniaga_custom_fields = collectMailNiagaCustomFields();
            }
            break;
        case 'add_to_googlesheets':
            data.spreadsheet_id = $('#gs_spreadsheet_id').val();
            data.spreadsheet_name = $('#gs_spreadsheet_name').val();
            data.sheet_name = $('#gs_sheet_name').val();
            data.gs_action = $('input[name=gs_action]:checked').val() || 'append_row';
            data.sheets_sub_action = data.gs_action;
            if (data.gs_action === 'append_row') {
                data.column_values = collectGsValues('#gsColumnValues', '.gs-col-row', '.gs-col-name', '.gs-col-value');
            } else {
                data.lookup_column = $('#gs_lookup_column').val();
                data.lookup_value = $('#gs_lookup_value').val();
                data.create_if_not_found = $('#gs_create_if_not_found').is(':checked');
                data.update_values = collectGsValues('#gsUpdateValues', '.gs-update-row', '.gs-upd-col', '.gs-upd-val');
            }
            break;
        case 'webhook':
            data.webhook_url = $('#webhook_url').val();
            data.webhook_method = $('#webhook_method').val();
            $.each(['query', 'headers', 'body'], function(i, section) {
                var enabled = $('#webhook_' + section + '_enabled').is(':checked');
                var mode = $('input[name=webhook_' + section + '_mode]:checked').val() || 'form';
                if (enabled) {
                    data[section + '_mode'] = mode;
                    data[section + '_params'] = collectWebhookParams(section);
                    data[section + '_raw'] = $('#webhook_' + section + '_raw').val() || '';
                } else {
                    data[section + '_mode'] = 'form';
                    data[section + '_params'] = [];
                    data[section + '_raw'] = '';
                }
            });
            break;
    }
    return data;
}

function collectDelayData() {
    return {
        action_type: 'delay',
        delay_type: $('input[name=delay_type]:checked').val() || 'period',
        delay_value: $('#delay_value').val(),
        delay_unit: $('#delay_unit').val(),
        delay_until_datetime: $('#delay_until_datetime').val()
    };
}

function collectConditionData() {
    var conditions = [];
    $('#conditionRows .condition-row').each(function() {
        conditions.push({
            field: $(this).find('.cond-field').val(),
            operator: $(this).find('.cond-operator').val(),
            value: $(this).find('.cond-value').val()
        });
    });
    return {
        action_type: 'condition',
        conditions: conditions,
        condition_logic: $('input[name=condition_logic]:checked').val() || 'AND'
    };
}

function collectGsValues(containerSel, rowSel, colSel, valSel) {
    var values = [];
    $(containerSel + ' ' + rowSel).each(function() {
        values.push({
            column: $(this).find(colSel).val(),
            value: $(this).find(valSel).val()
        });
    });
    return values;
}

function fetchSmsNiagaDropdowns(savedSenderId, savedGroupUuid) {
    var cfg = window.automationEditorConfig || {};
    var ic = (window.integrationConfig || {}).smsniaga || {};
    var defaultSender = ic.sender_id || '';

    var helpText = defaultSender
        ? 'If empty, uses <strong>' + defaultSender + '</strong> from settings'
        : 'No default sender ID configured in settings';
    $('#sms_sender_id_help').html(helpText);

    var $sender = $('#sms_sender_id');
    $sender.html('<option value="">-- Loading... --</option>');
    $.get(cfg.smsNiagaSenderIdsUrl).done(function(data) {
        $sender.html('<option value="">-- Use Default --</option>');
        $.each(data, function(key, val) {
            $sender.append('<option value="' + escapeHtml(key) + '"' + (key === savedSenderId ? ' selected' : '') + '>' + escapeHtml(val) + '</option>');
        });
        if (savedSenderId && !$sender.find('option[value="' + savedSenderId + '"]').length) {
            $sender.append('<option value="' + savedSenderId + '" selected>' + savedSenderId + '</option>');
        }
    }).fail(function() {
        $sender.html('<option value="">-- Unable to load --</option>');
        if (savedSenderId) {
            $sender.append('<option value="' + savedSenderId + '" selected>' + savedSenderId + '</option>');
        }
    });

    var $group = $('#sms_group_uuid');
    $group.html('<option value="">-- Loading... --</option>');
    $.get(cfg.smsNiagaGroupsUrl).done(function(data) {
        $group.html('<option value="">-- Select Group --</option>');
        $.each(data, function(i, g) {
            $group.append('<option value="' + escapeHtml(g.uuid) + '"' + (g.uuid === savedGroupUuid ? ' selected' : '') + '>' + escapeHtml(g.name) + '</option>');
        });
        if (savedGroupUuid && !$group.find('option[value="' + savedGroupUuid + '"]').length) {
            $group.append('<option value="' + savedGroupUuid + '" selected>' + savedGroupUuid + '</option>');
        }
    }).fail(function() {
        $group.html('<option value="">-- Unable to load --</option>');
        if (savedGroupUuid) {
            $group.append('<option value="' + savedGroupUuid + '" selected>' + savedGroupUuid + '</option>');
        }
    });
}

function fetchMailNiagaLists(version, savedListId) {
    var cfg = window.automationEditorConfig || {};
    var $sel = $('#mailniaga_list_id');
    $sel.html('<option value="">-- Loading... --</option>');

    $.get(cfg.mailNiagaListsUrl, { version: version }).done(function(data) {
        $sel.html('<option value="">-- Select List --</option>');
        $.each(data, function(i, l) {
            $sel.append('<option value="' + escapeHtml(l.id) + '"' + (l.id == savedListId ? ' selected' : '') + '>' + escapeHtml(l.name) + '</option>');
        });
        if (savedListId && !$sel.find('option[value="' + savedListId + '"]').length) {
            $sel.append('<option value="' + savedListId + '" selected>' + savedListId + '</option>');
        }
    }).fail(function() {
        $sel.html('<option value="">-- Unable to load --</option>');
        if (savedListId) {
            $sel.append('<option value="' + savedListId + '" selected>' + savedListId + '</option>');
        }
    });
}

function updateMailNiagaWarning() {
    var ver = $('input[name=mailniaga_version]:checked').val() || 'v1';
    var config = window.integrationConfig || {};
    var key = ver === 'v1' ? 'mailniaga_v1' : 'mailniaga_v2';
    var label = 'Mail Niaga ' + ver.toUpperCase();
    var info = config[key];
    var $warn = $('#integrationWarning');
    var settingsUrl = (window.automationEditorConfig || {}).integrationSettingsUrl || '#';
    var linkHtml = '<a href="' + settingsUrl + '" target="_blank">Integration Settings</a>';

    if (!info || (!info.enabled && !info.configured)) {
        $warn.removeClass('alert-warning alert-danger').addClass('alert-danger');
        $('#integrationWarningIcon').removeClass('text-warning text-danger').addClass('text-danger');
        $('#integrationWarningTitle').text(label + ' is disabled and not configured');
        $('#integrationWarningDesc').html('Please enable and configure credentials in ' + linkHtml + '.');
        $warn.css('display', 'flex');
    } else if (!info.enabled) {
        $warn.removeClass('alert-warning alert-danger').addClass('alert-warning');
        $('#integrationWarningIcon').removeClass('text-warning text-danger').addClass('text-warning');
        $('#integrationWarningTitle').text(label + ' is disabled');
        $('#integrationWarningDesc').html('This integration is currently disabled. Enable it in ' + linkHtml + '.');
        $warn.css('display', 'flex');
    } else if (!info.configured) {
        $warn.removeClass('alert-warning alert-danger').addClass('alert-danger');
        $('#integrationWarningIcon').removeClass('text-warning text-danger').addClass('text-danger');
        $('#integrationWarningTitle').text(label + ' credentials not configured');
        $('#integrationWarningDesc').html('API credentials are missing. Please configure in ' + linkHtml + '.');
        $warn.css('display', 'flex');
    } else {
        $warn.hide();
    }
}

function populatePanel(actionType, d) {
    switch (actionType) {
        case 'send_email':
            $('#email_to').val(d.email_to || '');
            $('#email_subject').val(d.email_subject || '');
            $('#email_body').val(d.email_body || '');
            break;
        case 'send_whatsapp':
            $('#whatsapp_to').val(d.whatsapp_to || '');
            $('#whatsapp_message').val(d.whatsapp_message || '');
            break;
        case 'send_wabot':
            $('#wabot_to').val(d.wabot_to || '');
            $('#wabot_message').val(d.wabot_message || '');
            break;
        case 'send_wasapbot':
            $('#wasapbot_to').val(d.wasapbot_to || '');
            $('#wasapbot_message').val(d.wasapbot_message || '');
            break;
        case 'add_to_smsniaga':
            $('input[name=sms_sub_action][value="' + (d.sms_sub_action || 'send_sms') + '"]').prop('checked', true).closest('label').addClass('active').siblings('label').removeClass('active').end().end().trigger('change');
            $('#sms_to').val(d.sms_to || '');
            $('#sms_message').val(d.sms_message || '');
            $('#sms_subscriber_name').val(d.sms_subscriber_name || '');
            $('#sms_subscriber_phone').val(d.sms_subscriber_phone || '');
            $('#sms_subscriber_email').val(d.sms_subscriber_email || '');
            fetchSmsNiagaDropdowns(d.sms_sender_id || '', d.sms_group_uuid || '');
            break;
        case 'add_to_mailniaga':
            var ver = d.mailniaga_version || 'v1';
            $('input[name=mailniaga_version][value="' + ver + '"]').prop('checked', true).closest('label').addClass('active').siblings('label').removeClass('active');
            $('#mailniaga_email').val(d.mailniaga_email || '');
            $('#mailniaga_name').val(d.mailniaga_name || '');
            fetchMailNiagaLists(ver, d.mailniaga_list_id || '');
            $('#mailniagaCustomFields').empty();
            if (ver === 'v2') {
                $('#mailniagaCustomFieldsWrapper').removeClass('d-none');
                if (d.mailniaga_list_id) {
                    fetchMailNiagaListFields(d.mailniaga_list_id, d.mailniaga_custom_fields || []);
                }
            } else {
                $('#mailniagaCustomFieldsWrapper').addClass('d-none');
            }
            break;
        case 'add_to_googlesheets':
            $('#gs_spreadsheet_id').val(d.spreadsheet_id || '');
            $('#gs_spreadsheet_name').val(d.spreadsheet_name || '');
            if (d.spreadsheet_id && !d.spreadsheet_name) {
                $('#gs_spreadsheet_name').val('ID: ' + d.spreadsheet_id.substring(0, 16) + '...');
            }
            $('input[name=gs_action][value="' + (d.gs_action || 'append_row') + '"]').prop('checked', true).closest('label').addClass('active').siblings('label').removeClass('active');
            toggleGsActionSections(d.gs_action || 'append_row');
            // Restore append section
            $('#gsColumnValues').empty();
            if (d.column_values && d.column_values.length) {
                d.column_values.forEach(function(cv) { addGsColumn(cv.column, cv.value); });
            } else {
                addGsColumn();
            }
            // Restore update section
            $('#gs_lookup_value').val(d.lookup_value || '');
            $('#gs_create_if_not_found').prop('checked', d.create_if_not_found || false);
            $('#gsUpdateValues').empty();
            if (d.update_values && d.update_values.length) {
                d.update_values.forEach(function(uv) { addGsUpdateRow(uv.column, uv.value); });
            } else {
                addGsUpdateRow();
            }
            // Restore sheet dropdown
            if (d.spreadsheet_id) {
                var savedSheet = d.sheet_name || '';
                var savedLookupCol = d.lookup_column || '';
                var $sel = $('#gs_sheet_name');
                $sel.html('<option value="">Loading...</option>').prop('disabled', true);
                $.get(automationEditorConfig.googleSheetsSpreadsheetUrl, { spreadsheet_id: d.spreadsheet_id }, function(res) {
                    $sel.prop('disabled', false).empty();
                    if (res.success && res.data && res.data.sheets) {
                        res.data.sheets.forEach(function(name) {
                            $sel.append('<option value="' + name + '"' + (name === savedSheet ? ' selected' : '') + '>' + name + '</option>');
                        });
                    } else {
                        $sel.html('<option value="' + savedSheet + '" selected>' + savedSheet + '</option>');
                    }
                    // Auto-fetch columns for both sections + lookup dropdown
                    var activeSheet = $sel.val();
                    if (activeSheet) {
                        populateGsLookupColumns(d.spreadsheet_id, activeSheet, savedLookupCol);
                        // Only auto-fetch headers if no saved data (new or empty node)
                        if (!d.column_values || !d.column_values.length) {
                            fetchGsHeaders('append');
                        }
                        if (!d.update_values || !d.update_values.length) {
                            fetchGsHeaders('update');
                        }
                    }
                }).fail(function() {
                    $sel.prop('disabled', false).html('<option value="' + savedSheet + '" selected>' + savedSheet + '</option>');
                });
            } else {
                $('#gs_sheet_name').html('<option value="">-- Select spreadsheet first --</option>');
            }
            break;
        case 'webhook':
            $('#webhook_url').val(d.webhook_url || '');
            $('#webhook_method').val(d.webhook_method || 'POST');
            $.each(['query', 'headers', 'body'], function(i, section) {
                var capSection = section.charAt(0).toUpperCase() + section.slice(1);
                var mode = d[section + '_mode'] || 'form';
                var params = d[section + '_params'] || [];
                var raw = d[section + '_raw'] || '';
                var hasData = params.length > 0 || raw;

                // Set values first
                $('#webhook_' + section + '_raw').val(raw);
                $('#webhook' + capSection + 'Params').empty();
                if (params.length) {
                    params.forEach(function(p) { addWebhookParam(section, p.key, p.value); });
                }

                // Set mode toggle
                $('input[name=webhook_' + section + '_mode][value="' + mode + '"]').prop('checked', true).closest('label').addClass('active').siblings('label').removeClass('active');
                if (mode === 'raw') {
                    $('#webhook' + capSection + 'Form').addClass('d-none');
                    $('#webhook' + capSection + 'Raw').removeClass('d-none');
                } else {
                    $('#webhook' + capSection + 'Form').removeClass('d-none');
                    $('#webhook' + capSection + 'Raw').addClass('d-none');
                }

                // Enable section last (shows the container)
                $('#webhook_' + section + '_enabled').prop('checked', hasData);
                $('#webhook' + capSection + 'Section').toggleClass('d-none', !hasData);
            });
            break;
    }
}

function populateDelayPanel(d) {
    $('input[name=delay_type][value="' + (d.delay_type || 'period') + '"]').prop('checked', true).closest('label').addClass('active').siblings('label').removeClass('active');
    $('input[name=delay_type]:checked').trigger('change');
    $('#delay_value').val(d.delay_value || '');
    $('#delay_unit').val(d.delay_unit || 'hours');
    $('#delay_until_datetime').val(d.delay_until_datetime || '');
}

function populateConditionPanel(d) {
    var conditions = d.conditions || [];
    // Destroy existing Select2 instances before clearing
    $('#conditionRows .condition-row select').each(function() {
        if ($(this).data('select2')) $(this).select2('destroy');
    });
    $('#conditionRows').empty();
    if (conditions.length === 0) {
        addConditionRow();
    } else {
        conditions.forEach(function(c) { addConditionRow(c); });
    }
    $('input[name=condition_logic][value="' + (d.condition_logic || 'AND') + '"]').prop('checked', true);
    $('#conditionNoTrigger').toggleClass('d-none', !!currentTriggerType);
}

function textValueMap(statuses) {
    var map = {};
    for (var k in statuses) {
        map[statuses[k]] = statuses[k];
    }
    return map;
}

function getStatusOptionsForField(field) {
    var statusFields = ['new_status', 'old_status', 'status'];
    if (statusFields.indexOf(field) === -1 && field !== 'transaction_status_code' && field !== 'transaction_status' && field !== 'mandate_status' && field !== 'commission_status') {
        return null;
    }

    if (currentTriggerType === 'transaction_status_changed') {
        return transactionStatuses;
    }
    if (currentTriggerType === 'mandate_status_changed') {
        return mandateStatuses;
    }
    if (currentTriggerType === 'referral_commission_status_changed') {
        return commissionStatuses;
    }

    if (field === 'transaction_status') return textValueMap(transactionStatuses);
    if (field === 'transaction_status_code') return transactionStatuses;
    if (field === 'mandate_status') return textValueMap(mandateStatuses);
    if (field === 'commission_status') return textValueMap(commissionStatuses);

    return null;
}

function buildValueInput(field, value, operator) {
    value = (value !== undefined && value !== null) ? value : '';
    var disabled = (operator === 'is_empty' || operator === 'is_not_empty');

    var statuses = getStatusOptionsForField(field);
    if (statuses && !disabled) {
        var opts = '<option value="">— Select Status —</option>';
        for (var k in statuses) {
            opts += '<option value="' + k + '"' + (String(value) == String(k) ? ' selected' : '') + '>' + statuses[k] + '</option>';
        }
        return '<select class="cond-value" style="width:100%">' + opts + '</select>';
    }

    if ((field === 'form_id' || field === 'form_title' || field === 'form_code') && !disabled) {
        var opts = '<option value="">— Select Form —</option>';
        if (field === 'form_id') {
            for (var k in formOptions) {
                opts += '<option value="' + escapeHtml(k) + '"' + (String(value) == String(k) ? ' selected' : '') + '>' + escapeHtml(formOptions[k]) + '</option>';
            }
        } else if (field === 'form_title') {
            for (var k in formOptions) {
                var title = formOptions[k];
                opts += '<option value="' + escapeHtml(title) + '"' + (value == title ? ' selected' : '') + '>' + escapeHtml(title) + '</option>';
            }
        } else if (field === 'form_code') {
            for (var k in formCodeOptions) {
                opts += '<option value="' + escapeHtml(formCodeOptions[k]) + '"' + (value == formCodeOptions[k] ? ' selected' : '') + '>' + escapeHtml(formCodeOptions[k]) + '</option>';
            }
        }
        return '<select class="cond-value" style="width:100%">' + opts + '</select>';
    }

    return '<input type="text" class="form-control cond-value" placeholder="Value" value="' + escapeHtml(value) + '"' + (disabled ? ' disabled' : '') + '>';
}

function onCondFieldChange(select) {
    var $row = $(select).closest('.condition-row');
    var field = $(select).val();
    var operator = $row.find('.cond-operator').val();
    var $oldVal = $row.find('.cond-value');
    if ($oldVal.data('select2')) $oldVal.select2('destroy');
    $row.find('.cond-value-wrap').html(buildValueInput(field, '', operator));
    initValueSelect2($row);
}

function onCondOperatorChange(select) {
    var $row = $(select).closest('.condition-row');
    var field = $row.find('.cond-field').val();
    var operator = $(select).val();
    var $oldVal = $row.find('.cond-value');
    var currentVal = $oldVal.val();
    if ($oldVal.data('select2')) $oldVal.select2('destroy');
    $row.find('.cond-value-wrap').html(buildValueInput(field, currentVal, operator));
    initValueSelect2($row);
}

function groupFieldsByPrefix(fields) {
    var prefixMap = {
        'tenant_': 'Global',
        'today_': 'Global',
        'participant_': 'Participant',
        'transaction_': 'Transaction',
        'mandate_': 'Mandate',
        'referral_agent_': 'Referral Agent',
        'commission_': 'Commission',
        'form_': 'Form'
    };
    var statusKeys = { 'old_status': 1, 'new_status': 1, 'status': 1 };
    var groups = {};

    for (var key in fields) {
        var group = 'Other';
        if (statusKeys[key]) {
            group = 'Status';
        } else {
            for (var prefix in prefixMap) {
                if (key.indexOf(prefix) === 0) {
                    group = prefixMap[prefix];
                    break;
                }
            }
        }
        if (!groups[group]) groups[group] = [];
        groups[group].push({ key: key, label: fields[key] });
    }

    return groups;
}

function addConditionRow(data) {
    data = data || {};
    var fields = triggerVariables[currentTriggerType] || {};
    var hasFields = Object.keys(fields).length > 0;
    var rowId = 'cond_' + Date.now() + '_' + Math.floor(Math.random() * 1000);

    var html = '<div class="condition-row border rounded p-2 mb-2" style="background:#f8f9fa;" id="' + rowId + '">';

    html += '<div class="d-flex align-items-stretch mb-2">';
    html += '<select class="cond-field flex-fill" style="width:100%">';
    html += '<option value="">— Select Field —</option>';
    if (hasFields) {
        var grouped = groupFieldsByPrefix(fields);
        for (var groupName in grouped) {
            var items = grouped[groupName];
            html += '<optgroup label="' + groupName + '">';
            for (var i = 0; i < items.length; i++) {
                html += '<option value="' + items[i].key + '"' + (data.field === items[i].key ? ' selected' : '') + '>' + items[i].label + '</option>';
            }
            html += '</optgroup>';
        }
    }
    html += '</select>';
    html += '<button type="button" class="btn btn-danger btn-sm btn-cond-delete ml-2" onclick="removeConditionRow(this)" title="Remove"><i class="fa fa-trash"></i></button>';
    html += '</div>';

    html += '<div class="form-row align-items-stretch">';
    html += '<div class="col-5">';
    html += '<select class="cond-operator" style="width:100%">';
    for (var op in conditionOperators) {
        html += '<option value="' + op + '"' + (data.operator === op ? ' selected' : '') + '>' + conditionOperators[op] + '</option>';
    }
    html += '</select>';
    html += '</div>';
    html += '<div class="col-7 cond-value-wrap">';
    html += buildValueInput(data.field || '', data.value || '', data.operator || 'equals');
    html += '</div>';
    html += '</div>';

    html += '</div>';
    $('#conditionRows').append(html);

    var $row = $('#' + rowId);
    $row.find('.cond-field').select2({ placeholder: '— Select Field —', allowClear: true, width: '100%', dropdownParent: $('#nodeEditorSlideover') })
        .on('change', function() { onCondFieldChange(this); });
    $row.find('.cond-operator').select2({ minimumResultsForSearch: Infinity, width: '100%', dropdownParent: $('#nodeEditorSlideover') })
        .on('change', function() { onCondOperatorChange(this); });
    initValueSelect2($row);
}

function initValueSelect2($row) {
    var $val = $row.find('.cond-value');
    if ($val.is('select')) {
        $val.select2({ placeholder: '— Select —', allowClear: true, width: '100%', dropdownParent: $('#nodeEditorSlideover') });
    }
}

function removeConditionRow(btn) {
    var $row = $(btn).closest('.condition-row');
    $row.find('select').each(function() {
        if ($(this).data('select2')) $(this).select2('destroy');
    });
    $row.remove();
}

function addGsColumn(name, value) {
    var html = '<div class="form-row mb-2 gs-col-row">';
    html += '<div class="col-5"><input type="text" class="form-control form-control-sm gs-col-name" placeholder="Column (e.g. Name)" value="' + (name || '') + '"></div>';
    html += '<div class="col-6"><input type="text" class="form-control form-control-sm gs-col-value var-target" placeholder="Value or {variable}" value="' + (value || '') + '"></div>';
    html += '<div class="col-1"><button type="button" class="btn btn-sm btn-danger" onclick="$(this).closest(\'.gs-col-row\').remove()"><i class="fa fa-trash"></i></button></div>';
    html += '</div>';
    $('#gsColumnValues').append(html);
}

(function() {
    var pickerReady = false;
    var script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.onload = function() {
        gapi.load('picker', function() { pickerReady = true; });
    };
    document.head.appendChild(script);

    $(document).on('click', '#btnOpenPicker', function() {
        var gc = (window.integrationConfig || {}).googlesheets || {};
        if (!gc.access_token) {
            alert('Please connect Google Sheets first in Integration settings.');
            return;
        }
        if (!gc.picker_api_key) {
            alert('Google Picker API key is not configured.');
            return;
        }
        if (!pickerReady) {
            alert('Google Picker is still loading. Please try again.');
            return;
        }

        var appId = '';
        if (gc.client_id) {
            var m = gc.client_id.match(/^(\d+)/);
            if (m) appId = m[1];
        }

        var view = new google.picker.DocsView(google.picker.ViewId.SPREADSHEETS)
            .setIncludeFolders(false)
            .setSelectFolderEnabled(false);

        new google.picker.PickerBuilder()
            .setAppId(appId)
            .setOAuthToken(gc.access_token)
            .setDeveloperKey(gc.picker_api_key)
            .addView(view)
            .setCallback(function(data) {
                if (data.action === google.picker.Action.PICKED) {
                    var doc = data.docs[0];
                    $('#gs_spreadsheet_id').val(doc.id);
                    $('#gs_spreadsheet_name').val(doc.name);
                    fetchGsSheets(true);
                }
            })
            .setTitle('Select a Spreadsheet')
            .build()
            .setVisible(true);
    });
})();

function toggleGsInputMode(mode) {
    if (mode === 'manual') {
        $('#gs_picker_mode').hide();
        $('#gs_manual_mode').show();
        var id = $('#gs_spreadsheet_id').val();
        if (id) $('#gs_manual_id').val(id);
    } else {
        $('#gs_manual_mode').hide();
        $('#gs_picker_mode').show();
    }
}

$(document).on('input', '#gs_manual_id', function() {
    $('#gs_spreadsheet_id').val(this.value);
    $('#gs_spreadsheet_name').val(this.value ? 'ID: ' + this.value.substring(0, 16) + '...' : '');
});

function fetchGsSheets(andThenFetchHeaders) {
    var id = $('#gs_spreadsheet_id').val();
    if (!id) { alert('Enter or select a spreadsheet first.'); return; }

    var $sel = $('#gs_sheet_name');
    $sel.html('<option value="">Loading...</option>').prop('disabled', true);

    $.get(automationEditorConfig.googleSheetsSpreadsheetUrl, { spreadsheet_id: id }, function(res) {
        $sel.prop('disabled', false);
        if (res.success && res.data && res.data.sheets) {
            $sel.empty();
            res.data.sheets.forEach(function(name) {
                $sel.append('<option value="' + name + '">' + name + '</option>');
            });
            if (!$('#gs_spreadsheet_name').val() && res.data.title) {
                $('#gs_spreadsheet_name').val(res.data.title);
            }
            if (andThenFetchHeaders) {
                fetchGsHeaders('append');
                fetchGsHeaders('update');
                populateGsLookupColumns();
            }
        } else {
            $sel.html('<option value="">Failed to load sheets</option>');
        }
    }).fail(function() {
        $sel.prop('disabled', false).html('<option value="">Error loading sheets</option>');
    });
}

function fetchGsHeaders(section) {
    section = section || 'append';
    var isUpdate = (section === 'update');
    var id = $('#gs_spreadsheet_id').val();
    var sheet = $('#gs_sheet_name').val();
    if (!id || !sheet) { alert('Select spreadsheet and sheet first.'); return; }

    var containerSel = isUpdate ? '#gsUpdateValues' : '#gsColumnValues';
    var rowClass = isUpdate ? '.gs-update-row' : '.gs-col-row';
    var colSel = isUpdate ? '.gs-upd-col' : '.gs-col-name';
    var valSel = isUpdate ? '.gs-upd-val' : '.gs-col-value';
    var addFn = isUpdate ? addGsUpdateRow : addGsColumn;

    var existing = {};
    $(containerSel + ' ' + rowClass).each(function() {
        var col = $(this).find(colSel).val();
        var val = $(this).find(valSel).val();
        if (col) existing[col] = val || '';
    });

    $(containerSel).html('<div class="text-muted text-12 py-2"><i class="fa fa-spinner fa-spin mr-1"></i> Fetching ' + (isUpdate ? 'columns' : 'headers') + '...</div>');

    $.get(automationEditorConfig.googleSheetsHeadersUrl, { spreadsheet_id: id, sheet_name: sheet }, function(res) {
        $(containerSel).empty();
        if (res.success && res.data && res.data.length) {
            res.data.forEach(function(header) {
                addFn(header, existing[header] || '');
            });
        } else {
            addFn();
        }
    }).fail(function() {
        $(containerSel).empty();
        addFn();
    });
}

$(document).on('change', '#gs_sheet_name', function() {
    if ($(this).val() && $('#gs_spreadsheet_id').val()) {
        fetchGsHeaders('append');
        fetchGsHeaders('update');
        populateGsLookupColumns();
    }
});

function toggleGsActionSections(action) {
    if (action === 'update_row') {
        $('#gsAppendSection').hide();
        $('#gsUpdateSection').show();
    } else {
        $('#gsAppendSection').show();
        $('#gsUpdateSection').hide();
    }
}

$(document).on('change', 'input[name=gs_action]', function() {
    toggleGsActionSections($(this).val());
    if ($('#gs_sheet_name').val() && $('#gs_spreadsheet_id').val()) {
        populateGsLookupColumns();
    }
});

function addGsUpdateRow(column, value) {
    var lookupOpts = $('#gs_lookup_column option').map(function() {
        return $(this).val();
    }).get().filter(function(v) { return v; });

    var html = '<div class="form-row mb-2 gs-update-row">';
    html += '<div class="col-5"><select class="form-control form-control-sm gs-upd-col">';
    html += '<option value="">-- Column --</option>';
    lookupOpts.forEach(function(h) {
        html += '<option value="' + h + '"' + (h === column ? ' selected' : '') + '>' + h + '</option>';
    });
    if (column && lookupOpts.indexOf(column) === -1) {
        html += '<option value="' + column + '" selected>' + column + '</option>';
    }
    html += '</select></div>';
    html += '<div class="col-6"><input type="text" class="form-control form-control-sm gs-upd-val var-target" placeholder="Value or {variable}" value="' + (value || '') + '"></div>';
    html += '<div class="col-1"><button type="button" class="btn btn-sm btn-danger" onclick="$(this).closest(\'.gs-update-row\').remove()"><i class="fa fa-trash"></i></button></div>';
    html += '</div>';
    $('#gsUpdateValues').append(html);
}

function populateGsLookupColumns(spreadsheetId, sheetName, savedLookupCol) {
    var id = spreadsheetId || $('#gs_spreadsheet_id').val();
    var sheet = sheetName || $('#gs_sheet_name').val();
    if (!id || !sheet) return;

    var $lookup = $('#gs_lookup_column');
    var saved = savedLookupCol || $lookup.val() || '';

    $.get(automationEditorConfig.googleSheetsHeadersUrl, { spreadsheet_id: id, sheet_name: sheet }, function(res) {
        $lookup.empty().append('<option value="">-- Select column --</option>');
        if (res.success && res.data && res.data.length) {
            res.data.forEach(function(header) {
                $lookup.append('<option value="' + header + '"' + (header === saved ? ' selected' : '') + '>' + header + '</option>');
            });
        }
    });
}

function addWebhookParam(section, key, value) {
    var capSection = section.charAt(0).toUpperCase() + section.slice(1);
    var placeholderKey = section === 'headers' ? 'Content-Type' : 'key';
    var placeholderVal = section === 'headers' ? 'application/json' : 'Use variable or input value';
    var html = '<div class="form-row mb-2 wh-param-row">';
    html += '<div class="col-5"><input type="text" class="form-control form-control-sm wh-param-key" placeholder="' + placeholderKey + '" value="' + (key || '') + '"></div>';
    html += '<div class="col-6"><input type="text" class="form-control form-control-sm wh-param-value var-target" placeholder="' + placeholderVal + '" value="' + (value || '') + '"></div>';
    html += '<div class="col-1"><button type="button" class="btn btn-sm btn-danger" onclick="$(this).closest(\'.wh-param-row\').remove()"><i class="fa fa-trash"></i></button></div>';
    html += '</div>';
    $('#webhook' + capSection + 'Params').append(html);
}

function collectWebhookParams(section) {
    var capSection = section.charAt(0).toUpperCase() + section.slice(1);
    var params = [];
    $('#webhook' + capSection + 'Params .wh-param-row').each(function() {
        var key = $(this).find('.wh-param-key').val();
        var val = $(this).find('.wh-param-value').val();
        if (key) {
            params.push({ key: key, value: val });
        }
    });
    return params;
}

function addMailNiagaCustomField(key, value) {
    var fields = window._mailNiagaListFields || [];
    var html = '<div class="form-row mb-2 mn-cf-row">';
    html += '<div class="col-5"><select class="form-control form-control-sm mn-cf-key">';
    html += '<option value="">-- Select Field --</option>';
    fields.forEach(function(f) {
        html += '<option value="' + f.key + '"' + (f.key === key ? ' selected' : '') + '>' + f.label + ' (' + f.key + ')</option>';
    });
    if (key && !fields.find(function(f) { return f.key === key; })) {
        html += '<option value="' + key + '" selected>' + key + '</option>';
    }
    html += '</select></div>';
    html += '<div class="col-6"><input type="text" class="form-control form-control-sm mn-cf-value var-target" placeholder="Use variable or input value" value="' + (value || '') + '"></div>';
    html += '<div class="col-1"><button type="button" class="btn btn-sm btn-danger" onclick="$(this).closest(\'.mn-cf-row\').remove()"><i class="fa fa-trash"></i></button></div>';
    html += '</div>';
    $('#mailniagaCustomFields').append(html);
}

function fetchMailNiagaListFields(listUid, savedCustomFields) {
    var cfg = window.automationEditorConfig || {};
    window._mailNiagaListFields = [];

    $.get(cfg.mailNiagaListFieldsUrl, { list_uid: listUid }).done(function(data) {
        window._mailNiagaListFields = data || [];
        $('#mailniagaCustomFields').empty();
        if (savedCustomFields && savedCustomFields.length) {
            savedCustomFields.forEach(function(f) { addMailNiagaCustomField(f.field_key, f.field_value); });
        }
    });
}

function collectMailNiagaCustomFields() {
    var fields = [];
    $('#mailniagaCustomFields .mn-cf-row').each(function() {
        var key = $(this).find('.mn-cf-key').val();
        var val = $(this).find('.mn-cf-value').val();
        if (key) {
            fields.push({ field_key: key, field_value: val });
        }
    });
    return fields;
}

function updateVariableDropdowns() {
    var vars = triggerVariables[currentTriggerType] || {};
    var html = '';
    if (Object.keys(vars).length) {
        html += '<div class="dropdown-header px-3 py-2" style="font-size:11px;color:#858796;"><i class="fa fa-mouse-pointer mr-1"></i> Click to insert or copy</div>';
        html += '<div class="dropdown-divider mt-0"></div>';
    }
    for (var key in vars) {
        var sample = getVarSample(key);
        html += '<button type="button" class="dropdown-item var-btn" data-var="{' + key + '}">'
            + '<div class="var-tag">{' + key + '}</div>'
            + '<div class="var-desc">' + vars[key] + (sample ? ' &middot; <em>' + sample + '</em>' : '') + '</div>'
            + '</button>';
    }
    if (!html) {
        html = '<span class="dropdown-item text-muted" style="font-size:12px;"><i class="fa fa-info-circle mr-1"></i> Select a trigger type first</span>';
    }
    $('.variable-dropdown-menu').html(html);
}

function getVarSample(key) {
    var samples = {
        tenant_name: 'Pertubuhan ABC', tenant_email: 'info@abc.org', tenant_tel_no: '03-12345678', tenant_website: 'https://abc.org',
        today_short: '09/03/2026', today_long: 'Ahad, 09 Mac 2026',
        participant_name: 'Ahmad bin Ali', participant_email: 'ahmad@email.com', participant_tel_no: '60123456789',
        participant_address: '123 Jalan Merdeka', participant_postcode: '50000', participant_city: 'Kuala Lumpur',
        participant_state: 'WP Kuala Lumpur', participant_country: 'Malaysia',
        transaction_id: 'BC-12345678', transaction_amount: '50.00', transaction_amount_value: '50',
        transaction_status: 'Successful', transaction_status_code: '3',
        transaction_datetime: '2026-03-09 15:30:00', transaction_created_at: '2026-03-09 15:00:00',
        transaction_fpx_ref_no: 'FPX-REF-001', transaction_receipt_no: 'RCP-001',
        transaction_description: 'Derma Ramadan', transaction_remarks: '', transaction_currency: 'MYR',
        form_title: 'Tabung Masjid', form_code: 'TM-2026', form_id: '1',
        referral_agent_code: 'REF-ALI01', referral_agent_name: 'Ali Imran',
        referral_agent_id: '42', referral_agent_email: 'ali@email.com', referral_agent_tel_no: '60171234567',
        mandate_id: '5678', mandate_hashid: 'md_Yd71Dq', mandate_reference: 'MDT-5678',
        mandate_status: 'Active', mandate_status_code: '3',
        mandate_overall_status: 'Terminated', mandate_overall_status_code: '4',
        mandate_frequency: 'monthly', mandate_amount: '100.00',
        commission_id: '99', commission_amount: '5.00', commission_amount_value: '5',
        commission_status: 'approved',
        custom_field_1: 'Nama Arwah', custom_field_2: 'Catatan', custom_field_3: 'Lain-lain',
        old_status: '1', new_status: '3', status: '3'
    };
    return samples[key] || '';
}

function showVarCopiedToast(varText) {
    var $toast = $('<div class="var-copied-toast"><i class="fa fa-check mr-1"></i> Copied ' + varText + '</div>');
    $('#workflow-wrapper').append($toast);
    setTimeout(function() { $toast.addClass('show'); }, 10);
    setTimeout(function() { $toast.removeClass('show'); setTimeout(function() { $toast.remove(); }, 200); }, 1500);
}

function showConfirmModal(opts, callback) {
    $('#confirmIcon').html(opts.icon).css('color', opts.color || '#333');
    $('#confirmTitle').text(opts.title);
    $('#confirmMessage').text(opts.message);
    $('#confirmBtn').attr('class', 'btn btn-sm px-4 ' + (opts.btnClass || 'btn-primary')).text(opts.btnText || 'Confirm');
    $('#confirmBtn').off('click').on('click', function() {
        $('#confirmModal').modal('hide');
        callback();
    });
    $('#confirmModal').modal('show');
}

function toggleAutomationActive() {
    var cfg = window.automationEditorConfig || {};
    if (!cfg.toggleActiveUrl) return;
    var $btn = $('#btnToggleActive');
    var isCurrentlyActive = $btn.hasClass('btn-danger');

    showConfirmModal({
        icon: isCurrentlyActive ? '<i class="fad fa-pause-circle"></i>' : '<i class="fad fa-play-circle"></i>',
        color: isCurrentlyActive ? '#dc3545' : '#28a745',
        title: isCurrentlyActive ? 'Deactivate Automation?' : 'Activate Automation?',
        message: isCurrentlyActive
            ? 'This automation will stop running. No new triggers will be processed.'
            : 'This automation will start running and process new triggers.',
        btnClass: isCurrentlyActive ? 'btn-danger' : 'btn-success',
        btnText: isCurrentlyActive ? 'Deactivate' : 'Activate'
    }, function() {
        $btn.prop('disabled', true);
        $.post(cfg.toggleActiveUrl, { _token: cfg.csrfToken }, function(res) {
            $btn.prop('disabled', false);
            if (res.is_active) {
                $btn.removeClass('btn-success').addClass('btn-danger');
                $btn.find('i').removeClass('fa-play-circle').addClass('fa-check-circle');
                $btn.find('span').text('Deactivate');
            } else {
                $btn.removeClass('btn-danger').addClass('btn-success');
                $btn.find('i').removeClass('fa-check-circle').addClass('fa-play-circle');
                $btn.find('span').text('Activate');
            }
        }).fail(function() {
            $btn.prop('disabled', false);
            alert('Failed to toggle automation status.');
        });
    });
}

// Expose functions for inline onclick handlers (webpack module scope)
window.openTriggerSlideover = openTriggerSlideover;
window.closeTriggerSlideover = closeTriggerSlideover;
window.selectTrigger = selectTrigger;
window.filterTriggers = filterTriggers;
window.closeActionSlideover = closeActionSlideover;
window.selectAction = selectAction;
window.filterActions = filterActions;
window.openNodeEditor = openNodeEditor;
window.closeNodeEditor = closeNodeEditor;
window.saveCurrentNode = saveCurrentNode;
window.toggleTestArea = toggleTestArea;
window.executeTest = executeTest;
window.addConditionRow = addConditionRow;
window.removeConditionRow = removeConditionRow;
window.addGsColumn = addGsColumn;
window.toggleGsInputMode = toggleGsInputMode;
window.fetchGsSheets = fetchGsSheets;
window.fetchGsHeaders = fetchGsHeaders;
window.addGsUpdateRow = addGsUpdateRow;
window.toggleGsActionSections = toggleGsActionSections;
window.addWebhookParam = addWebhookParam;
window.addMailNiagaCustomField = addMailNiagaCustomField;
window.toggleFullscreen = toggleFullscreen;
window.toggleAutomationActive = toggleAutomationActive;
window.showConfirmModal = showConfirmModal;
